export const agentEvidenceGuide = {
  title: 'How to hand off a browser bug to your AI coding agent',
  slug: 'handoff-browser-bug-recording-coding-agent',
  date: '2026-10-20',
  description: 'Give your AI coding agent a browser bug recording and a clear investigation brief. Includes a bug report template, example, and copyable prompt. Start with Rill Free.',
} as const;
